var React = require('react');

function CircleCheck (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"}));
}

CircleCheck.defaultProps = {"height":"1em","viewBox":"0 0 512 512"};

module.exports = CircleCheck;

CircleCheck.default = CircleCheck;
